import { render } from "./index.vue?vue&type=template&id=30d12a68&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=30d12a68&lang=scss&scoped=true"

import exportComponent from "E:\\sunjibo\\upstream_space\\code\\shenzhou\\medical-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30d12a68"]])

export default __exports__